import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from '../services/locale.service';

const MINUTE = 1000 * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const DAYS_BEFORE_ABSOLUTE_DATE = 30;

@Pipe({
    name: 'timeElapsed',
    standalone: false
})
export class TimeElapsedPipe implements PipeTransform {

  private readonly translateService = inject(TranslateService);
  private readonly localeService = inject(LocaleService);

  public transform(value: string | Date | number): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    const elapsed = Math.abs(Date.now() - date.getTime());

    if (elapsed < HOUR) {
      return this.translateService.instant('COMMON.minutes-short-format', { minutes: Math.max(1, Math.floor(elapsed / MINUTE)) });
    }

    if (elapsed < DAY) {
      return this.translateService.instant('COMMON.hours-short-format', { hours: Math.floor(elapsed / HOUR) });
    }

    const days = Math.floor(elapsed / DAY);

    if (days < DAYS_BEFORE_ABSOLUTE_DATE) {
      return this.translateService.instant('COMMON.days-short-format', { days });
    }

    return new Intl.DateTimeFormat(this.localeService.localeValue || undefined, { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
  }

}
